<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card class="card-content mt-10">
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title text-lg">
              {{ $t("assign_student.list_of_student") }}
            </h4>
          </div>
        </md-card-header>
        <md-card-content>
          <no-data-found v-if="!infoForm.length"></no-data-found>
          <div
            v-else
            class="md-layout py-5 items-center"
            v-for="(info, index) in infoForm"
            :key="index + 'infoForm'"
          >
            <!-- avatar -->
            <div
              class="md-layout-item md-size-20 md-small-size-30 items-center"
            >
              <img
                :src="info.avatar_url || '/img/avt_placeholder.jpg'"
                alt="Avatar counselor"
                class="object-cover rounded-full w-16 h-16 md:w-24 md:h-24"
              />
            </div>
            <!-- avatar -->

            <div class="md-layout-item md-size-20 px-0 pr-2">
              <p class="text-[gray]">{{ $t("common.full_name") }}</p>
              <router-link :to="'/students/' + info._id + '/detail'"
                ><span class="text-[blue]">{{
                  info.full_name
                }}</span></router-link
              >
            </div>
            <div class="md-layout-item md-size-10 px-0 pr-2">
              <p class="text-[gray]">{{ $t("common.grade") }}</p>
              <p>
                <span>{{ info.grade }}</span>
              </p>
            </div>
            <div class="md-layout-item md-size-15 px-0 pr-2">
              <p class="text-[gray]">{{ $t("common.student_code") }}</p>
              <router-link :to="'/students/' + info._id + '/detail'"
                ><span class="text-[blue]">{{
                  info.student_code
                }}</span></router-link
              >
            </div>
            <div class="md-layout-item md-size-20 px-0 pr-2">
              <p class="text-[gray]">{{ $t("common.email") }}</p>
              <p>
                <span>{{ info.email }}</span>
              </p>
            </div>
            <div class="md-layout-item md-size-10 px-0 pr-2">
              <p class="text-[gray]">{{ $t("common.phone_number") }}</p>
              <p>
                <span>{{ info.phone_number }}</span>
              </p>
            </div>
            <!--            <div
                          class="md-layout-item md-size-5 px-0 pr-2 hidden lg:block"
                          v-if="!isModeSupporter"
                        >
                          <md-card class="rounded-2xl w-[45px] h-[45px]">
                            <md-button
                              class="md-button md-just-icon md-simple"
                              @click="connectChat(info)"
                            >
                              <md-icon>chat</md-icon>
                            </md-button>
                          </md-card>
                        </div>-->
          </div>
        </md-card-content>
        <yv-pagination
          :pagination="pagination"
          @changePage="changePage"
        ></yv-pagination>
      </md-card>
    </div>
  </div>
</template>

<script>
import { service_paths } from "@/constants/Services";
import { mapGetters } from "vuex";
import NoDataFound from "@/components/Base/Illustration/NoDataFound";
import YvPagination from "@/components/Base/YvPagination";
import { getId } from "@/helpers/utils";

export default {
  components: { YvPagination, NoDataFound },
  data() {
    return {
      infoForm: [],
      params: {},
      pagination: {
        perPage: 10,
        from: 0,
        to: 0,
        total: 0,
        currentPage: 1,
        hidePaging: false,
        hidePerPageOptions: false
      }
    };
  },
  computed: {
    ...mapGetters("user", {
      userInfo: "info"
    })
    // ...mapGetters("chat", { isModeSupporter: "isModeSupporterLocal" })
  },
  created() {
    this.getListStudentAssigned();
  },
  methods: {
    /*async connectChat(user) {
     const userId = getId(user);
     let { data } = await this.$axios.post(
     `${service_paths.chat}/direct/users/${userId}`
     );
     const roomIdUser = getId(data);
     const route = this.$router.resolve({
     name: chat_room_names.listPage,
     query: { direct_id: roomIdUser }
     });
     window.open(route.href, "_blank");
     },*/
    changePage() {
      this.params.page = this.pagination.currentPage;
      this.params.limit = this.pagination.perPage;
      this.getListStudentAssigned();
    },
    getListStudentAssigned() {
      const path = `${service_paths.users}/${getId(
        this.userInfo
      )}/assigned-students`;
      this.$axios.get(path, this.params).then(response => {
        this.infoForm = response.data.data;
        this.pagination.from = response.data.from;
        this.pagination.to = response.data.to;
        this.pagination.total = response.data.total;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card {
  box-shadow: 0 1px 4px 0 #49494980;
}

.md-layout {
  border-bottom: 1px solid #ddd;
}
</style>
